import { connect } from 'react-redux'

export default function withLanguage(WrappedComponent) {
  return connect(({ info: { language } }) => {
    return { language }
  })(WrappedComponent)
}



// WEBPACK FOOTER //
// ./src/components/templates/lang-select/withLanguage.js